
import axios from "axios";
import { store } from "store";
import { OutputBaseProps } from "utils/types/API";
import { StatusItemProps } from ".";
import { loading, find } from "store/status";

interface ApiStatusFindByIdInputProps {
    id: number;
}

type ApiStatusFindOutputProps = OutputBaseProps<{ item: StatusItemProps; }, ApiStatusFindByIdInputProps>

export const apiStatusFindById = async (data: ApiStatusFindByIdInputProps) => {
    store.dispatch(loading());
    const res = (await axios.get<ApiStatusFindOutputProps>(`/api/status/${data.id}`))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(find({ data: res.data.item }));
    }
    return res;
};


interface ApiStatusFindByCodeInputProps {
    code: string;
}

export const apiStatusFindByCode = async (data: ApiStatusFindByCodeInputProps) => {
    store.dispatch(loading());
    const res = (await axios.get<ApiStatusFindOutputProps>(`/api/status/code/${data.code}`))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(find({ data: res.data.item }));
    }
    return res;
};